import { createApi } from '@stilingue/st-auth-utils';
import { isProdVersion } from '@stilingue/st-environment-controller-utils';
import { featureFlagFlags } from '@/plugins/rollout';
import Service from './Service';
import gateway from './Gateway';

const version = isProdVersion()
  ? featureFlagFlags.DbManagerServiceVersionProd.getValue()
  : featureFlagFlags.DbManagerServiceVersionStaging.getValue();

const afterParser = response => response.data;

class CompanyService extends Service {
  constructor(gatewayService, versionService) {
    const api = createApi(`upms-legacy/${versionService}/`, gatewayService);

    super(api, {
      afterParser,
      retriesLimit: 3,
    });

    this.api.http.defaults.timeout = 300000;
  }

  getCompanies(id) {
    return this.find({
      url: `user/${id}/companies`,
    });
  }

  getCompanyByName(params = {}) {
    return this.api.get({ params, url: 'company' }).then(this.afterParser);
  }
}

export default new CompanyService(gateway, version);

